import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'tellent-assistant-thinking-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="dots" aria-hidden="true">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </span>
    <span class="label">Thinking…</span>
  `,
  styleUrls: ['./tellent-assistant-thinking-indicator.component.less'],
  host: { role: 'status', 'aria-live': 'polite' },
})
export class TellentAssistantThinkingIndicatorComponent {}
